import { Component, Vue } from 'vue-property-decorator';

import Single from '@/components/single/single.vue';

@Component({
    components: {
        Single,
    },
})
export default class Thanks extends Vue {
    tabs: any[] = [];

    active: number | null = null;

    loaded = 0;

    mounted() {
        this.getData();
    }

    async getData() {
        const document = await this.$prismic.client.getSingle('donors');

        for (const year of document.data.donor_year) {
            this.tabs.push(year);
        }

        this.onLoad();
    }

    onLoad() {
        this.loaded += 1;

        if (this.loaded > 1) {
            this.$emit('load');
        }
    }
}
